import React from "react";
import PageHero from "@/components/shared/PageHero";
import GallerySection from "@/components/sections/GallerySection";

export default function GalleryPage() {
    return (
        <>
            <PageHero
                testId="gallery-page"
                eyebrow="Gallery"
                chapter="Archive · 01"
                title="Gallery."
                subtitle="An editorial archive of gatherings, initiatives and community moments — treated as photography, not stock."
            />
            <GallerySection />
        </>
    );
}
